import styled from '@emotion/styled'
import theme from '@utils/theme'
import Button from '@components/button'

export const StyleBankWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 20px;
  box-shadow: ${theme.colors.boxShadow};
  border-radius: 12px;
  padding: 12px;
`

export const StyledActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 12px;
  gap: 14px;
`
export const RejectButton = styled(Button)`
  border: 1px solid ${theme.colors.red};
  color: ${theme.colors.red};
  background: transparent;
  border-radius: 14px;
  padding: 20px 50px;
`
export const ApproveButton = styled(Button)`
  border-radius: 14px;
  padding: 20px 50px;
`
